<ul class="usa-nav__primary usa-accordion">
  <li class="usa-nav__primary-item">
    <a
      [routerLink]="['/']"
      routerLinkActive="usa-current"
      [routerLinkActiveOptions]="{ exact: true }"
      class="usa-nav-link"
      tabindex="0"
      >PLANTS Database Home
    </a>
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/topics']" routerLinkActive="usa-current" class="usa-nav-link" tabindex="0"
      >Topics</a
    >
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/team']" routerLinkActive="usa-current" tabindex="0">Team</a>
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/downloads']" routerLinkActive="usa-current" tabindex="0">Downloads</a>
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/partners']" routerLinkActive="usa-current" tabindex="0">Partners</a>
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/tools']" routerLinkActive="usa-current" tabindex="0">Related Tools</a>
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/help']" routerLinkActive="usa-current" tabindex="0">Help</a>
  </li>
  <li class="usa-nav__primary-item">
    <a [routerLink]="['/release-notes']" routerLinkActive="usa-current" tabindex="0"
      >Release Notes</a
    >
  </li>
</ul>
